<template lang="pug">
article#account

    .container
        .column
            h3.header-6 General Settings
            button.caps.primary(@click="doLogout" :disabled="loggingOut") Logout
        .divider
        .column
            h3.header-6 Quickbooks Settings
            //- div.row
            //-     include ../resources/icons/check-box-empty.pug
            //-     include ../resources/icons/check-box-checked.pug
            //-     include ../resources/icons/check-box-null.pug
            div.row.center-align
                h5.subheader Status
                span.center-align.loading(v-if="isLoading")
                    span.box
                        include ../resources/icons/check-box-empty.pug
                    span Loading...
                span.center-align.setup(v-else-if="isSetup")
                    span.box
                        include ../resources/icons/check-box-checked.pug
                    span Connected
                span.center-align.not-set(v-else)
                    span.box
                        include ../resources/icons/check-box-null.pug
                    span Not Connected
                //- div.info(@click="setShowInfo(!showInfo)" @mouseenter="setShowInfo(true)" @mouseleave="setShowInfo(false)")
            div.row.no-wrap
                button.caps.secondary(@click="doQuickbooks" :disabled="isLoading")
                    template(v-if="isLoading") Loading...
                    template(v-else-if="isSetup") Connect Again
                    template(v-else) Connect Quickbooks
                span.info
                    span
                        include ../resources/icons/help.pug
                    //- .info-box(v-show="showInfo")
                    .info-box
                        p Quickbooks Account authorization token will expire after 100 days.
                        p Use of the Managment Portal enables the auth token to refresh automatically.
                        p The account can also be mannually refreshed using the "Connect" button.
                            //- .g-center(v-if="isSetup") Quickbooks is set up!
    Modal(v-if="waiting")
        #quickbooks-popup {{ message }}

</template>

<script setup lang="ts">
import Modal from '@/components/Modal.vue';
import { useQuickbooksSetup } from '@/composables/useQuickbooksSetup';
import { useAuth } from '@/store/auth';
import { ref } from 'vue';
import { useRouter } from 'vue-router';

const showInfo = ref(false);
function setShowInfo( x: boolean){
    showInfo.value = x
}

const auth       = useAuth();
const router     = useRouter();
const loggingOut = ref(false);
const { waiting, message, doLinkQuickbooks, isLoading, isSetup, } = useQuickbooksSetup();

async function doLogout() {
    loggingOut.value = true;
    await auth.signOut();
    await router.push({name: 'login'});
    loggingOut.value = false;
}

async function doQuickbooks() {
    await doLinkQuickbooks();
}

</script>

<style lang="scss">

article#account {
    &,.container{
        height: 100%;
    }
    .container {
        place-content: flex-start;
        gap: 1rem;
        margin: 4rem auto;
        max-width:  30rem;
        // border: 1px dashed red;
        display: grid;
        grid-auto-flow: column;
        grid-template-columns: 35% 5% 55%;
    }
    h3.header-6 {
        // margin-bottom: 1em;
    }
    .column {
        grid-auto-flow: row;
        display: grid;
        align-content: space-between;
        height: 12rem;
        button{
            width: 100%;
            height: 2.75rem;
            font-size: 1rem;

        }
    }
    .divider {
        height: 100%;
        width: 0px;
        border-right: $border-black-1;
        margin:auto;
    }
    .row{
        min-width: max-content;
        overflow-wrap:normal;
        width: 100%;
        display: grid;
        gap: 0.5rem;

        h5, button{
            display: inline-block;
        }
    }
    .icon{
        height: 2rem;
        width:  2rem;
        .path{
            fill: $color-gray-63;
        }
        &.unchecked .path,
        &.null .path{
            fill: $color-primary;
        }
        &.checked .path{
            fill: $color-green;
        }
        &.help{
            height: 2.5rem;
            width:  2.5rem;
            outline: 2px solid $color-blue;
            outline-offset: -1px;
            border-radius: 50%;
            .path{
                fill: $color-blue;
            }
        }
    }
    h5.subheader{
        font-size: 1.25rem;
        font-weight: 400;
    }
    .center-align{
        display: flex;
        align-items: center;
        line-height: 100%;
        display: grid;
        gap: 0.5rem;
        grid-auto-flow: column;
        width: fit-content;
    }
    span.info{
        position: relative;
        display: block;
        width: fit-content;
        max-width: 2.75rem;
            .info-box{
                bottom: -1rem;
                left: 50%;
                transform: translate(-50%, 100%);
                position: absolute;
                // position: fixed;
                padding: 2rem;
                background: $color-white;
                border: $border-black-1;
                border-radius: $border-radius-card;
                width: 20rem;
            }
        & .info-box{
            display: none;
        }
        &:hover,
        &:focus,
        &:active{
            cursor: pointer;
            .info-box{
                display: inherit;
            }
        }
    }
    .no-wrap{
        width: 100%;
        grid-auto-flow: column;
        grid-template-columns: 1fr 3rem;
    }
    div.row > button.caps.secondary{
        width: calc(100% - 3rem);
    }
}

</style>